import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAssignappQuestionnaire = (assignappQuestionnaireId) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  useEffect(() => {
    if (!assignappQuestionnaireId) return;

    const fetchQuestionnaire = async () => {
      startLoading();
      const response = await apiGet(`/questionnaires/${assignappQuestionnaireId}/show_questionnaire_with_survey`, "Error al obtener el cuestionario");
      setResponse(response);
    };

    fetchQuestionnaire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignappQuestionnaireId]);

  return { data, error, loading };
};

export default useFetchAssignappQuestionnaire;
